import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../../Styles/Theme';
import {Chip, Card, CardContent, CardMedia, IconButton, Typography, Box } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import '../../../Styles/GeneralStyles.css';
import Button from "@mui/material/Button";
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {CLIENTES_CONSIGNAS_PIEZAS} from '../../../Constants/routesConstants'

const ConsignaLlegadas = (props) => {
    const navigate = useNavigate();

    return (
        <>
            <ThemeProvider theme={Theme}>
                <Grid>
                    <Grid item xs={4} sm={8} md={12} lg={12} elevation={12}>
                        <Grid Grid item xs={4} sm={4} md={4} lg={12} className='d-flex align-center mb-30'>
                        <Button
                                className='back-gradient-4 bord-radius-10 shadow font-letter font-light'
                                startIcon={<ArrowBackIcon />}
                                onClick={function () {
                                    navigate(CLIENTES_CONSIGNAS_PIEZAS)
                                }}
                            >
                                Regresar
                            </Button>
                            <Chip icon={<MonetizationOnIcon />} label='Consigna / Mis piezas / Recien llegadas' color='primary' className='back-transparent font-letter font-barter font-20' />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container direction='row' justifyContent='center' alignItems='center' spacing={2} elevation={12}>
                        <Grid item xs={4}>
                            <Card sx={{ display: 'flex', height: 200 }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: 151 }}
                                    image="https://images.unsplash.com/photo-1522312346375-d1a52e2b99b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=394&q=80"
                                    alt="Live from space album cover"
                                />
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ flex: '1 0 auto' }}>
                                        <Typography component="div" variant="h5">
                                            Rolex
                                        </Typography>
                                        <Typography variant="subtitle1" color="text.secondary" component="div">
                                            Recien llegado
                                        </Typography>
                                        {/* <Typography variant="subtitle1" color="text.secondary" component="div">
                                            El producto se encuentra en tránsito, hacia tu guardarropa.
                                        </Typography> */}
                                        <Typography variant="subtitle1" color="text.secondary" component="div">
                                            Fecha: 01/11/2022
                                        </Typography>
                                    </CardContent>

                                </Box>

                            </Card>
                        </Grid>

                        <Grid item xs={4}>
                            <Card sx={{ display: 'flex', height: 200 }}>
                                <CardMedia
                                    component="img"
                                    sx={{ width: 151 }}
                                    image="https://images.unsplash.com/photo-1580331451062-99ff652288d7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
                                    alt="Live from space album cover"
                                />
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <CardContent sx={{ flex: '1 0 auto' }}>
                                        <Typography component="div" variant="h5">
                                            Gucci
                                        </Typography>
                                        <Typography variant="subtitle1" color="text.secondary" component="div">
                                            Recien llegado
                                        </Typography>
                                        {/* <Typography variant="subtitle1" color="text.secondary" component="div">
                                            El producto se encuentra en tránsito, hacia tu guardarropa.
                                        </Typography> */}
                                        <Typography variant="subtitle1" color="text.secondary" component="div">
                                            Fecha: 25/10/2022
                                        </Typography>
                                    </CardContent>
                                </Box>
                            </Card>
                        </Grid>
                        <Grid item xs={4}>
                           
                        </Grid>
                    </Grid>

                </Grid>
            </ThemeProvider>
        </>
    )
}

export default ConsignaLlegadas